import React, {useState} from 'react';
import {Button, Comment, Grid, TextArea} from 'semantic-ui-react';
import {parseTimestampToDatetime} from "../../utils/dateUtils";
import {Formik} from "formik";
import FileInputWrapper from "../FileInputWrapper";
import TableFileViewerWrapper from "../TableFileViewerWrapper";
import PropTypes from "prop-types";
import {withTranslation} from "react-i18next";
import FileThumbnails from "../FileThumbnails";
import Avatar from "../Avatar";

const CommentsWrapper = ({comments, saveCommentAction, canAddComment, t, getCustomMetaData, getCommentStyle, getCommentKey, withFiles, filesProp, creatorProp, commentProp, commentDateProp, showAvatar, api}) => {

	const [temporalComment, updateTemporalComment] = useState('');
	const [temporalCommentFiles, updateTemporalCommentFiles] = useState([]);

	const addComment = () => {
		if(temporalComment !== '' || temporalCommentFiles.length > 0){
			saveCommentAction([temporalComment, temporalCommentFiles.flatMap(f=>f.fileData)]);
			updateTemporalComment('');
			updateTemporalCommentFiles([]);
		}
	};

	return (
		<Grid>
			{canAddComment && <Grid.Row columns={1} style={{padding: 0, margin: '0px 0px 10px 0px'}}>
				<Grid.Column width={16} style={{padding: 0, margin: 0}}>
					<TextArea
						style={{padding: 0}}
						onChange={e => updateTemporalComment(e.target.value)}
						value={temporalComment}
					/>
					{withFiles && <div style={{marginTop: '3px'}}>
						<Formik enableReinitialize={true}  initialValues={{temporalCommentFiles}}
										render={formikProps => (
											<FileInputWrapper
												{...formikProps}
												name="temporalCommentFiles"
												fileDataProp="fileData"
												value={formikProps.values.temporalCommentFiles}
												onChange={updateTemporalCommentFiles}
												displayOnlyFirstLevelErrors={true}
												multiple={true}
												fileViewerRender={props => temporalCommentFiles.length > 0 ? <TableFileViewerWrapper api={api} {...props}/> : null}
											/>
										)}
						/>
					</div>}
				</Grid.Column>
				<Grid.Column width={16} style={{paddingRight: 0, marginTop: '3px'}}>
					<Button
						style={{float: 'right', margin: 0}}
						compact
						size='small'
						icon='plus'
						content={t('add_comment')}
						onClick={() => addComment()}
					/>
				</Grid.Column>
			</Grid.Row>}
			<Grid.Row style={{padding: 0, margin: '0px 0px 10px 0px'}} className='commentsRow'>
				<Grid.Column width={16} style={{padding: 0, overflow: 'auto', maxHeight: '450px'}}>
					<Comment.Group style={{display: 'inline'}}>
						{
							comments.map(c =>
								<Comment
									style={getCommentStyle(c)}
									key={getCommentKey(c)}>
									<Comment.Content>
										<Grid style={{margin: 0, padding: 0}}>
											<Grid.Row columns={2} style={{padding: 0, margin: 0}}>
												{showAvatar && c[creatorProp] && <Grid.Column width={1} style={{padding: 0, margin: 0}}>
													<Avatar backgroundId={c[creatorProp].id} lastName={c[creatorProp].lastName} firstName={c[creatorProp].firstName}/>
												</Grid.Column>}
												<Grid.Column width={showAvatar ? 15 : 16} style={{
													paddingLeft: '10px',
													margin: 0,
													justifyItems: 'center',
													alignItems: 'center',
													display: 'flex'
												}}>
													<Comment.Author as='b' style={{textDecoration: 'underline'}}>
														{c[creatorProp] && c[creatorProp].name}
													</Comment.Author>
													<Comment.Metadata>
														<div>{parseTimestampToDatetime(c[commentDateProp])}</div>
														{getCustomMetaData(c)}
													</Comment.Metadata>
												</Grid.Column>
											</Grid.Row>
										</Grid>
										<Comment.Text style={{marginBottom: '0px'}}>
											{c[commentProp]}
										</Comment.Text>
										{withFiles && c[filesProp] && <FileThumbnails files={c[filesProp]} api={api} isSelfDownloadThumbnail={true}/>}
									</Comment.Content>
								</Comment>
							)
						}
					</Comment.Group>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

CommentsWrapper.propTypes = {
	comments: PropTypes.array.isRequired,
	saveCommentAction: PropTypes.func.isRequired
};

CommentsWrapper.defaultProps = {
	canAddComment: false,
	getCustomMetaData: comment => null,
	getCommentStyle: comment => null,
	getCommentKey: comment => "commentKey" + comment.id,
	showAvatar: true,
	withFiles: false,
	filesProp: 'files',
	commentProp: 'comment',
	commentDateProp: 'createdDate',
	creatorProp: 'creator'
};

export default withTranslation() (CommentsWrapper);
